export type MovieType = 'movie' | 'tv';

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  actors: string[];
  synopsis: string;
  tags: string[];
  views: number;
  updatedAt: string;
  featured: boolean;
  cover: string;
}

export const movies: Movie[] = [
  {
    id: 'xinghai-mihang',
    title: '星海迷航',
    type: 'movie',
    genres: ['科幻', '冒险'],
    region: '美国',
    year: 2024,
    rating: 8.7,
    duration: '142分钟',
    director: 'Ethan Cole',
    actors: ['Marcus Reed', 'Lena Ortiz', 'David Chan'],
    synopsis:
      '一支深空探测队在木星轨道附近发现了失联数十年的殖民地信号，当飞船驶入那片诡异的星海，队员们逐渐意识到，真正需要逃离的并不是宇宙，而是彼此之间被改写的记忆。影片以宏大的太空场景与克制的情感表达，讲述了一段关于信任与归途的故事。',
    tags: ['科幻', '太空', '悬疑', '冒险'],
    views: 982000,
    updatedAt: '2024-09-12',
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%20of%20a%20lone%20spaceship%20drifting%20near%20a%20golden%20gas%20giant%20planet%2C%20deep%20navy%20cosmos%20with%20warm%20amber%20nebula%20glow%2C%20dramatic%20lighting%2C%20high%20detail%20digital%20painting&width=480&height=720&seq=movie-cover-01&orientation=portrait',
  },
  {
    id: 'changan-yexing',
    title: '长安夜行',
    type: 'tv',
    genres: ['古装', '悬疑'],
    region: '中国大陆',
    year: 2023,
    rating: 9.0,
    duration: '全42集',
    director: '沈知远',
    actors: ['顾清和', '柳诗屿', '陆铭'],
    synopsis:
      '上元灯节当夜，长安城内接连发生离奇命案，年轻的司直与女仵作被迫联手调查。随着线索层层深入，一桩尘封二十年的旧案浮出水面，繁华盛世的阴影之下，是权谋与人心交织的暗流。',
    tags: ['古装', '悬疑', '探案', '权谋'],
    views: 1254000,
    updatedAt: '2023-11-20',
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20dynasty%20mystery%20drama%20poster%2C%20lantern%20lit%20night%20street%20in%20old%20capital%2C%20navy%20blue%20tones%20with%20warm%20orange%20lantern%20glow%2C%20misty%20atmospheric%2C%20oriented%20painting%20style&width=480&height=720&seq=movie-cover-02&orientation=portrait',
  },
  {
    id: 'zhuifengzhe',
    title: '追风者',
    type: 'movie',
    genres: ['动作', '犯罪'],
    region: '中国香港',
    year: 2023,
    rating: 7.9,
    duration: '128分钟',
    director: '陈嘉朗',
    actors: ['周子曜', '林晓岚', '高天'],
    synopsis:
      '一名卧底警探在追查跨境走私集团时身份暴露，一夜之间成为全城追捕的目标。为了活下去并完成最后的任务，他必须在天亮前穿过整座城市，把证据送到唯一还能信任的人手中。',
    tags: ['动作', '犯罪', '警匪', '追车'],
    views: 866000,
    updatedAt: '2023-08-03',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Gritty%20action%20crime%20movie%20poster%20of%20a%20lone%20man%20running%20through%20a%20neon%20lit%20midnight%20city%2C%20dark%20navy%20tones%20with%20orange%20street%20light%20streaks%2C%20motion%20blur%2C%20cinematic%20mood&width=480&height=720&seq=movie-cover-03&orientation=portrait',
  },
  {
    id: 'shenhai-huisheng',
    title: '深海回声',
    type: 'movie',
    genres: ['科幻', '悬疑'],
    region: '英国',
    year: 2022,
    rating: 8.2,
    duration: '116分钟',
    director: 'Oliver Grant',
    actors: ['Sophie Hale', 'Adam Fletcher', 'Nina Boyle'],
    synopsis:
      '海洋研究所的声呐团队在六千米深海捕捉到一段有规律的信号，它既像人类语言，又像某种回应。当团队决定下潜查看，深海之下的真相远比信号本身更加令人不安。',
    tags: ['科幻', '悬疑', '深海', '惊悚'],
    views: 612000,
    updatedAt: '2022-06-18',
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=Atmospheric%20sci-fi%20thriller%20poster%20of%20a%20deep%20sea%20submersible%20descending%20into%20dark%20ocean%2C%20cold%20navy%20blue%20depths%20with%20a%20single%20warm%20submarine%20light%2C%20mysterious%20cinematic%20tone&width=480&height=720&seq=movie-cover-04&orientation=portrait',
  },
  {
    id: 'chunri-laixin',
    title: '春日来信',
    type: 'tv',
    genres: ['爱情', '剧情'],
    region: '韩国',
    year: 2024,
    rating: 8.5,
    duration: '全16集',
    director: 'Kim Ji-woo',
    actors: ['Han Seo-yeon', 'Park Min-ho', 'Jung Da-eun'],
    synopsis:
      '在城市书店工作的女孩每月都会收到一封没有寄件人的信，字迹温柔却总落在她最想被安慰的时刻。当她沿着信封上的旧邮戳寻找，一段被时间藏起的温柔往事缓缓展开。',
    tags: ['爱情', '剧情', '治愈', '都市'],
    views: 1043000,
    updatedAt: '2024-05-27',
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20romantic%20drama%20poster%20of%20a%20sunlit%20bookshop%20window%20with%20handwritten%20letters%2C%20soft%20cream%20and%20amber%20tones%2C%20gentle%20bokeh%20lights%2C%20cozy%20cinematic%20mood&width=480&height=720&seq=movie-cover-05&orientation=portrait',
  },
  {
    id: 'anye-shouhuzhe',
    title: '暗夜守护者',
    type: 'tv',
    genres: ['犯罪', '动作'],
    region: '美国',
    year: 2023,
    rating: 8.3,
    duration: '全10集',
    director: 'Rachel Monroe',
    actors: ['Kevin Doyle', 'Amara Blake', 'Tom Ritter'],
    synopsis:
      '一支由退伍军人组成的民间治安小队，在白天的普通身份与夜晚的守护行动之间小心维持平衡。当城市的犯罪网络开始反击，他们不得不面对自己过去的伤口。',
    tags: ['犯罪', '动作', '都市', '悬疑'],
    views: 733000,
    updatedAt: '2023-10-09',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20urban%20crime%20series%20poster%20of%20a%20silhouetted%20figure%20on%20a%20rainy%20rooftop%20overlooking%20a%20city%20at%20night%2C%20deep%20navy%20and%20orange%20city%20lights%2C%20cinematic%20noir%20atmosphere&width=480&height=720&seq=movie-cover-06&orientation=portrait',
  },
  {
    id: 'shanhai-shiguang',
    title: '山海食光',
    type: 'movie',
    genres: ['动画', '奇幻'],
    region: '日本',
    year: 2024,
    rating: 8.9,
    duration: '108分钟',
    director: '佐藤 悠',
    actors: ['三浦 彩', '中村 拓真', '小林 雪'],
    synopsis:
      '在传说中吃下就能记起故乡味道的山海小馆里，一位迷路的少年跟着神秘的老板娘，开始替过往的客人做一道只属于他们的菜。热气蒸腾之间，被遗忘的记忆重新有了滋味。',
    tags: ['动画', '奇幻', '治愈', '美食'],
    views: 891000,
    updatedAt: '2024-07-14',
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20anic%20Japanese%20animation%20film%20poster%20of%20a%20tiny%20mountain%20food%20stall%20glowing%20at%20dusk%2C%20steaming%20bowls%2C%20twilight%20navy%20sky%20with%20amber%20lantern%20light%2C%20hand%20drawn%20style&width=480&height=720&seq=movie-cover-07&orientation=portrait',
  },
  {
    id: 'niguang-erxing',
    title: '逆光而行',
    type: 'movie',
    genres: ['剧情', '励志'],
    region: '中国大陆',
    year: 2022,
    rating: 8.0,
    duration: '124分钟',
    director: '许以南',
    actors: ['江砚', '苏晚', '郑明川'],
    synopsis:
      '曾因伤病退役的田径运动员回到小城，在废弃的操场上遇到了一群没人愿意带的少年。他用最笨的办法重新学习奔跑，也带着这群孩子一起，跑向属于自己的光。',
    tags: ['剧情', '励志', '青春', '运动'],
    views: 487000,
    updatedAt: '2022-12-01',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Inspirational%20sports%20drama%20poster%20of%20runners%20silhouetted%20against%20a%20golden%20backlit%20sunrise%20on%20an%20old%20track%2C%20warm%20amber%20light%20with%20navy%20shadows%2C%20hopeful%20cinematic%20mood&width=480&height=720&seq=movie-cover-08&orientation=portrait',
  },
  {
    id: 'miwu-xiaozhen',
    title: '迷雾小镇',
    type: 'tv',
    genres: ['悬疑', '犯罪'],
    region: '英国',
    year: 2023,
    rating: 8.6,
    duration: '全8集',
    director: 'Harriet Lowe',
    actors: ['Grace Whitfield', 'Daniel Shaw', 'Ella Ramsey'],
    synopsis:
      '一名外地警探被派往常年被浓雾笼罩的湖边小镇调查失踪案，却发现镇上几乎每个人都对那天夜里发生的事守口如瓶。雾散之前，他必须分清谁在说谎，谁在守护真相。',
    tags: ['悬疑', '犯罪', '小镇', '推理'],
    views: 654000,
    updatedAt: '2023-04-22',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Eerie%20mystery%20drama%20poster%20of%20a%20foggy%20lakeside%20town%20with%20a%20single%20street%20lamp%20glowing%2C%20cold%20navy%20mist%20with%20amber%20light%20haze%2C%20cinematic%20suspense%20atmosphere&width=480&height=720&seq=movie-cover-09&orientation=portrait',
  },
  {
    id: 'shiguang-youchai',
    title: '时光邮差',
    type: 'movie',
    genres: ['爱情', '奇幻'],
    region: '韩国',
    year: 2021,
    rating: 8.1,
    duration: '112分钟',
    director: 'Lee Soo-hyun',
    actors: ['Choi Eun-bi', 'Yang Jun-seo', 'Bae Ha-rin'],
    synopsis:
      '一位老邮差发现自己邮包里多了一封写着未来日期的信，寄信人正是几十年前的他。为了把这封信送到对的人手上，他踏上了一段横跨时光的温柔旅程。',
    tags: ['爱情', '奇幻', '治愈', '穿越'],
    views: 402000,
    updatedAt: '2021-09-30',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20film%20poster%20of%20a%20vintage%20mailman%20bicycle%20on%20an%20autumn%20lane%20scattered%20with%20letters%2C%20soft%20amber%20and%20navy%20tones%2C%20dreamy%20cinematic%20mood&width=480&height=720&seq=movie-cover-10&orientation=portrait',
  },
  {
    id: 'gangtie-liming',
    title: '钢铁黎明',
    type: 'movie',
    genres: ['动作', '科幻'],
    region: '美国',
    year: 2023,
    rating: 7.6,
    duration: '134分钟',
    director: 'Carl Jensen',
    actors: ['Ryan Cole', 'Mia Sanders', 'Owen Park'],
    synopsis:
      '在能源枯竭的近未来，一名退役机械师被迫驾驶旧型号装甲守卫最后一座城市。当敌人越过防线，他必须决定是守住机器，还是守住机器背后的人。',
    tags: ['动作', '科幻', '机甲', '末世'],
    views: 578000,
    updatedAt: '2023-06-11',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Blockbuster%20sci-fi%20action%20poster%20of%20a%20giant%20mechanical%20armor%20standing%20before%20a%20ruined%20city%20at%20dawn%2C%20steel%20navy%20tones%20with%20orange%20sunrise%20glow%2C%20epic%20cinematic%20scale&width=480&height=720&seq=movie-cover-11&orientation=portrait',
  },
  {
    id: 'jianghu-xiaotan',
    title: '江湖笑谈',
    type: 'tv',
    genres: ['喜剧', '古装'],
    region: '中国香港',
    year: 2022,
    rating: 7.8,
    duration: '全30集',
    director: '麦子豪',
    actors: ['何家俊', '倪小柔', '梁颂'],
    synopsis:
      '一家开在官道旁的小酒馆，每天迎来各路自称大侠的客人。老板与伙计为了守住这间铺子，靠一张嘴和一身普通功夫，把江湖上的恩怨都化解成了一场场啼笑皆非的误会。',
    tags: ['喜剧', '古装', '江湖', '轻喜'],
    views: 366000,
    updatedAt: '2022-03-15',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20wuxia%20comedy%20series%20poster%20of%20a%20lively%20ancient%20tavern%20with%20colorful%20lanterns%2C%20warm%20amber%20and%20navy%20tones%2C%20humorous%20chinese%20painting%20style&width=480&height=720&seq=movie-cover-12&orientation=portrait',
  },
  {
    id: 'xingchen-zhixia',
    title: '星辰之下',
    type: 'tv',
    genres: ['剧情', '家庭'],
    region: '中国大陆',
    year: 2024,
    rating: 8.4,
    duration: '全28集',
    director: '林知微',
    actors: ['宋之言', '王淑芬', '陈星宇'],
    synopsis:
      '一座老工厂即将关闭，三代同堂的李家面临着搬迁、就业与亲情的三重考验。在时代转身的缝隙里，这个普通家庭努力守住彼此，也守住了属于自己的星辰。',
    tags: ['剧情', '家庭', '年代', '现实'],
    views: 521000,
    updatedAt: '2024-08-19',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Heartwarming%20family%20drama%20poster%20of%20a%20warmly%20lit%20old%20apartment%20window%20at%20night%20under%20a%20starry%20sky%2C%20deep%20navy%20with%20amber%20interior%20glow%2C%20nostalgic%20cinematic%20mood&width=480&height=720&seq=movie-cover-13&orientation=portrait',
  },
  {
    id: 'liangzi-bianjie',
    title: '量子边界',
    type: 'movie',
    genres: ['科幻', '惊悚'],
    region: '美国',
    year: 2022,
    rating: 7.7,
    duration: '118分钟',
    director: 'Nadia Fischer',
    actors: ['Leo Hart', 'Chloe Vance', 'Sam Okafor'],
    synopsis:
      '一名量子物理学家在一次实验事故后，开始在不同版本的人生之间不受控制地切换。为了回到最初的世界，他必须在无数个自己当中找出唯一真实的那个。',
    tags: ['科幻', '惊悚', '悬疑', '平行世界'],
    views: 449000,
    updatedAt: '2022-10-25',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Mind%20bending%20sci-fi%20thriller%20poster%20of%20a%20man%20reflected%20into%20many%20parallel%20versions%20in%20a%20glowing%20lab%2C%20electric%20navy%20tones%20with%20orange%20energy%20lines%2C%20cinematic%20tension&width=480&height=720&seq=movie-cover-14&orientation=portrait',
  },
  {
    id: 'dongjing-yuji',
    title: '东京雨季',
    type: 'movie',
    genres: ['爱情', '剧情'],
    region: '日本',
    year: 2023,
    rating: 7.5,
    duration: '104分钟',
    director: '中岛 凉',
    actors: ['松本 优', '石井 真央', '大野 健'],
    synopsis:
      '在连续下雨的东京，一位插画师与一位代笔作家因为同一把遗落的伞相识。两人约定只在雨天见面，却在这个小小的约定里，慢慢学会了面对各自的晴天。',
    tags: ['爱情', '剧情', '文艺', '都市'],
    views: 298000,
    updatedAt: '2023-05-06',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Melancholic%20romance%20film%20poster%20of%20two%20figures%20sharing%20one%20umbrella%20on%20a%20rainy%20Tokyo%20street%2C%20muted%20navy%20tones%20with%20warm%20orange%20shop%20lights%2C%20soft%20bokeh%20rain&width=480&height=720&seq=movie-cover-15&orientation=portrait',
  },
  {
    id: 'wusheng-zhengci',
    title: '无声证词',
    type: 'tv',
    genres: ['悬疑', '犯罪'],
    region: '中国大陆',
    year: 2023,
    rating: 8.5,
    duration: '全24集',
    director: '贺兰舟',
    actors: ['韩沐', '周筱', '林致远'],
    synopsis:
      '一位失语的法医与一位固执的老刑警组成搭档，用解剖台上的细节替死者说话。当一桩看似普通的事故案不断指向二十年前的旧案，沉默终于发出最响亮的证词。',
    tags: ['悬疑', '犯罪', '法医', '推理'],
    views: 689000,
    updatedAt: '2023-12-13',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Cerebral%20crime%20investigation%20poster%20of%20a%20dim%20forensic%20lab%20with%20a%20single%20desk%20lamp%2C%20cold%20navy%20shadows%20with%20amber%20light%20pool%2C%20restrained%20cinematic%20suspense&width=480&height=720&seq=movie-cover-16&orientation=portrait',
  },
  {
    id: 'wangzhe-guilai',
    title: '王者归来',
    type: 'movie',
    genres: ['动作', '历史'],
    region: '中国大陆',
    year: 2024,
    rating: 7.4,
    duration: '138分钟',
    director: '秦牧',
    actors: ['霍青云', '杨昭', '陆文轩'],
    synopsis:
      '被贬边疆的旧将接到一纸密令，要他带兵收复失守多年的关隘。面对旧日的袍泽与陌生的战场，他必须用一场几乎不可能赢下的战役，证明忠诚的分量。',
    tags: ['动作', '历史', '战争', '史诗'],
    views: 556000,
    updatedAt: '2024-04-08',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20historical%20war%20film%20poster%20of%20an%20armored%20general%20standing%20before%20a%20mountain%20fortress%20at%20dusk%2C%20deep%20navy%20sky%20with%20orange%20banner%20fire%2C%20grand%20cinematic%20scale&width=480&height=720&seq=movie-cover-17&orientation=portrait',
  },
  {
    id: 'huanjing-qiyuan',
    title: '幻境奇缘',
    type: 'movie',
    genres: ['奇幻', '冒险'],
    region: '法国',
    year: 2022,
    rating: 8.0,
    duration: '110分钟',
    director: 'Claire Dubois',
    actors: ['Antoine Mercier', 'Camille Roux', 'Julien Blanc'],
    synopsis:
      '一位爱画画的小女孩在阁楼里发现了一扇通往绘本国度的门，可那个世界正因为失去想象力而褪色。为了救回色彩，她必须完成一幅只属于自己的画。',
    tags: ['奇幻', '冒险', '童话', '治愈'],
    views: 341000,
    updatedAt: '2022-07-27',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20adventure%20poster%20of%20a%20young%20girl%20stepping%20into%20a%20painterly%20dream%20world%20of%20floating%20islands%2C%20rich%20navy%20and%20amber%20palette%2C%20storybook%20illustration%20style&width=480&height=720&seq=movie-cover-18&orientation=portrait',
  },
  {
    id: 'dushi-fuchen',
    title: '都市浮尘',
    type: 'tv',
    genres: ['剧情', '都市'],
    region: '中国大陆',
    year: 2022,
    rating: 7.9,
    duration: '全36集',
    director: '苏若水',
    actors: ['孟一凡', '顾佳宁', '许铭'],
    synopsis:
      '三个从同一个小城来到大城市打拼的年轻人，在跌跌撞撞的十年里各自走散又重新相遇。他们追逐过的东西有的成了真，有的成了灰，但没有人真正停下脚步。',
    tags: ['剧情', '都市', '现实', '成长'],
    views: 432000,
    updatedAt: '2022-11-09',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20a%20city%20skyline%20at%20dusk%20seen%20through%20an%20office%20window%2C%20cool%20navy%20tones%20with%20warm%20orange%20sunset%20glow%2C%20cinematic%20melancholy&width=480&height=720&seq=movie-cover-19&orientation=portrait',
  },
  {
    id: 'jidi-jiuyuan',
    title: '极地救援',
    type: 'movie',
    genres: ['动作', '冒险'],
    region: '美国',
    year: 2024,
    rating: 7.8,
    duration: '126分钟',
    director: 'Grant Miller',
    actors: ['Jack Norris', 'Ivy Larson', 'Mateo Ruiz'],
    synopsis:
      '一场突如其来的暴风雪让南极科考站与外界彻底失联，一名救援飞行员在执行任务途中被迫降落。在零下四十度的冰原上，他要带着被困的队员走完最后一段路。',
    tags: ['动作', '冒险', '灾难', '求生'],
    views: 613000,
    updatedAt: '2024-10-02',
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=Intense%20survival%20thriller%20poster%20of%20a%20rescue%20plane%20on%20a%20vast%20icy%20polar%20plain%20in%20a%20blizzard%2C%20cold%20navy%20white%20with%20orange%20headlamp%20glow%2C%20cinematic%20scale&width=480&height=720&seq=movie-cover-20&orientation=portrait',
  },
];

export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  genres: string[];
  year: number;
  rating: number;
  short: string;
  backdrop: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 'xinghai-mihang',
    title: '星海迷航',
    subtitle: '当记忆被宇宙改写，唯一能依靠的只有彼此',
    genres: ['科幻', '冒险'],
    year: 2024,
    rating: 8.7,
    short: '深空探测队在木星轨道发现失联殖民地的信号，一段关于信任与归途的太空之旅就此展开。',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20lone%20spaceship%20silhouetted%20against%20a%20massive%20golden%20amber%20planet%20in%20deep%20navy%20space%2C%20dramatic%20backlighting%2C%20high%20detail%20sci-fi%20digital%20painting%2C%20dark%20tones%20for%20text%20overlay&width=1600&height=900&seq=hero-bd-01&orientation=landscape',
  },
  {
    id: 'changan-yexing',
    title: '长安夜行',
    subtitle: '灯火长安，藏着一桩二十年的旧案',
    genres: ['古装', '悬疑'],
    year: 2023,
    rating: 9.0,
    short: '上元灯节命案接连发生，年轻司直与女仵作联手追查，揭开盛世之下的暗流。',
    backdrop:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20ancient%20Chinese%20capital%20city%20at%20night%20with%20thousands%20of%20glowing%20lanterns%2C%20deep%20navy%20blue%20sky%20with%20warm%20orange%20lantern%20light%2C%20misty%20atmospheric%20epic%20scene%2C%20dark%20tones%20for%20text%20overlay&width=1600&height=900&seq=hero-bd-02&orientation=landscape',
  },
  {
    id: 'chunri-laixin',
    title: '春日来信',
    subtitle: '有些温柔，会穿过时间抵达你',
    genres: ['爱情', '剧情'],
    year: 2024,
    rating: 8.5,
    short: '书店女孩每月收到没有寄件人的信，沿着旧邮戳，一段被时间藏起的往事缓缓展开。',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cozy%20cinematic%20wide%20shot%20of%20a%20sunlit%20vintage%20bookshop%20interior%20with%20floating%20handwritten%20letters%20in%20soft%20amber%20light%2C%20warm%20cream%20and%20navy%20tones%2C%20dreamy%20bokeh%2C%20dark%20edges%20for%20text%20overlay&width=1600&height=900&seq=hero-bd-03&orientation=landscape',
  },
  {
    id: 'shanhai-shiguang',
    title: '山海食光',
    subtitle: '每一道菜，都记得你来自哪里',
    genres: ['动画', '奇幻'],
    year: 2024,
    rating: 8.9,
    short: '山海小馆里，迷路少年替客人做出一道道只属于他们的菜，热气之间记忆有了滋味。',
    backdrop:
      'https://readdy.ai/api/search-image?query=Beautiful%20anime%20wide%20scene%20of%20a%20tiny%20mountain%20food%20stall%20glowing%20at%20dusk%20with%20steaming%20bowls%2C%20twilight%20navy%20sky%20with%20warm%20amber%20lantern%20light%2C%20hand%20drawn%20detailed%20background%2C%20dark%20edges%20for%20text%20overlay&width=1600&height=900&seq=hero-bd-04&orientation=landscape',
  },
  {
    id: 'shenhai-huisheng',
    title: '深海回声',
    subtitle: '六千米之下，有什么在回应我们',
    genres: ['科幻', '悬疑'],
    year: 2022,
    rating: 8.2,
    short: '深海声呐捕捉到有规律的信号，既像语言又像回应，真相远比信号更令人不安。',
    backdrop:
      'https://readdy.ai/api/search-image?query=Atmospheric%20deep%20ocean%20cinematic%20scene%20of%20a%20submersible%20descending%20into%20dark%20abyss%20with%20a%20single%20warm%20searchlight%20beam%2C%20cold%20navy%20blue%20depths%2C%20mysterious%20mood%2C%20dark%20tones%20for%20text%20overlay&width=1600&height=900&seq=hero-bd-05&orientation=landscape',
  },
];

export const genreShortcuts: { label: string; icon: string; type: string; desc: string }[] = [
  { label: '电影', icon: 'ri-movie-2-line', type: 'movie', desc: '院线大片与经典佳作' },
  { label: '电视剧', icon: 'ri-tv-2-line', type: 'tv', desc: '热播剧集一次看爽' },
  { label: '动作', icon: 'ri-sword-line', type: '动作', desc: '拳拳到肉的高能场面' },
  { label: '爱情', icon: 'ri-heart-3-line', type: '爱情', desc: '关于心动的所有模样' },
  { label: '科幻', icon: 'ri-rocket-2-line', type: '科幻', desc: '通往未来的想象力' },
  { label: '悬疑', icon: 'ri-search-eye-line', type: '悬疑', desc: '层层反转，烧脑不停' },
];

export const allGenres: string[] = [
  '动作',
  '爱情',
  '科幻',
  '悬疑',
  '喜剧',
  '犯罪',
  '动画',
  '奇幻',
  '剧情',
  '古装',
  '冒险',
];

export const allRegions: string[] = ['中国大陆', '中国香港', '美国', '韩国', '日本', '英国', '法国'];

export const allYears: number[] = [2024, 2023, 2022, 2021];